module.exports = __webpack_public_path__ + "img/rocket.9bbc4d2c.svg";